const initialAppFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
};


export const CardRegistrationReducer = (state = initialAppFilterState, action) => {
  switch (action.type) {

    case "CREATE_CARD_REGISTRATION_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "CREATE_CARD_REGISTRATION_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        nbResult: nbResult
      };
    }

    case "CREATE_CARD_REGISTRATION_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        nbResult: 0,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/MangoPay/cardRegistrationReducer.js